<template>
    <div>
    <div :class="modalClasses" :style="{ zIndex }">
        <div v-if="closeButton === 'outset'" class="side-modal-controls">
            <div class="side-modal-close-btn" @click="toggle">
                <span class="material-icons">close</span>
            </div>
        </div>
        <div class="side-modal-panel">
            <div class="ui-modal__header" v-if="!hideHeader">
                <slot name="header">
                    <h1 class="ui-modal__header-text">{{ title }}</h1>
                </slot>

                <div v-if="closeButton === 'inset'" class="ui-modal__close-button">
                    <ui-close-button
                        @click="close"
                    ></ui-close-button>
                </div>
            </div>
            <div class="side-modal-content">
                <slot />
            </div>
            <div v-if="!hideFooter" style="padding: 10px 20px; border-top: 1px solid #ccc; position: absolute; bottom: 0; left: 1px; background: white;z-index: 110; width: 100%;">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
        <div v-if="isOpen" style="background: rgba(0,0,0,0.3); backdrop-filter: blur(3px); position: fixed; top: 0; left: 0; zIndex: 52; bottom: 0; width: 100vw; height: 100vh;"></div>
    </div>
</template>

<script>
export default {
    name: "SideModal",
    props: {
        title: {
            type: String,
            default: 'Modal',
        },
        size: {
            type: String,
            default: 'default'
        },
        hideHeader: {
            type: Boolean,
            default: false,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
        closeButton: {
            type: String,
            default: 'inset'
        },
        zIndex: {
            type: Number,
            default: 53
        }
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        open() {
            this.$emit('opening')
            this.isOpen = true
        },
        close() {
            this.$emit('closing')
            this.isOpen = false
        },
        toggle() {
            this.isOpen = !this.isOpen
        }
    },
    computed: {
        modalClasses() {
            return [
                'side-modal-container',
                this.isOpen ? 'open' : false,
                `side-modal-size-${this.size}`
            ].filter(v => !!v)
        }
    }
}
</script>

<style scoped lang="scss">
    .side-modal-container {
        position: fixed;
        top: 0; right: -1220px; bottom: 0;
        width: 1120px;
        transition: right .25s ease-in-out;
        z-index: 53;

        &.side-modal-size-small {
            width: 320px;
            right: -420px;
        }

         &.side-modal-size-wide {
            right: calc(-90vw - 100px);
            width: 90vw;
             max-width: 1300px;
        }

        &.open { right: 0; }

        .side-modal-controls {
            position: absolute;
            left: -50px;
            top: 10px;

            .side-modal-close-btn {
                padding: .2rem .25rem .25rem;
                border-radius: 5px;
                background-color: white;
                box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
                border: 1px solid #ddd;
                cursor: pointer;

                &:hover {
                    background-color: darken(white, 5%);
                }

                .material-icons { vertical-align: middle; }
            }
        }

        .side-modal-panel {
            height: 100%;
            background: white;
            box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
            border-left: 1px solid #ddd;

            .side-modal-content {
                height: 100%;
            }
        }
    }
</style>